// /assets/section-about-reschio-collections.js
(() => {
    const MQ = "(min-width: 1000px)";
    const mq = window.matchMedia(MQ);
    const MAX_SHIFT = 300;
    let sections = [];
    let scrollAttached = false;
    let rafId = null;
    function applyImageHeightFromData(root = document) {
        root.querySelectorAll(".section-about-reschio-collections .mobile-image[data-height]").forEach(pic => {
        const h = parseFloat(pic.dataset.height);
            if (!isNaN(h)) pic.style.setProperty("--image-height", `${h}vh`);
        });
    }
    function collectSections(root = document) {
        return Array.from(root.querySelectorAll(".section-about-reschio-collections")).map(section => ({
            section,
            left: section.querySelectorAll(".desktop-images-wrapper.is-left picture:not(.image-center)"),
            right: section.querySelectorAll(".desktop-images-wrapper.is-right picture:not(.image-center)")
        }));
    }
    function handleParallax() {
        rafId = null;
        if (!mq.matches || !sections.length) return;

        const viewportH = window.innerHeight;
        const scrollY = window.scrollY;

        sections.forEach(({ section, left, right }) => {
            const rect = section.getBoundingClientRect();
            const sectionTop = scrollY + rect.top;
            const sectionH = rect.height;
            if (scrollY + viewportH < sectionTop || scrollY > sectionTop + sectionH) return;

            const progress = (scrollY + viewportH - sectionTop) / (sectionH + viewportH); // 0..1
            const shift = (progress - 0.5) * 2 * MAX_SHIFT; // -MAX..+MAX

            const up = (-0.4 * shift).toFixed(2);
            const down = (0.4 * shift).toFixed(2);

            left.forEach(img => { img.style.transform = `translate3d(0, ${up}px, 0)`; });
            right.forEach(img => { img.style.transform = `translate3d(0, ${down}px, 0)`; });
        });
    }

    function onScroll() {
        if (rafId == null) rafId = requestAnimationFrame(handleParallax);
    }

    function attachScroll() {
        if (scrollAttached) return;
        window.addEventListener("scroll", onScroll, { passive: true });
        scrollAttached = true;
    }

    function detachScroll() {
        if (!scrollAttached) return;
        window.removeEventListener("scroll", onScroll);
        scrollAttached = false;
    }

    function resetTransforms() {
        sections.forEach(({ left, right }) => {
            [...left, ...right].forEach(img => { img.style.transform = "translate3d(0,0,0)"; });
        });
    }

    function init(root = document) {
        applyImageHeightFromData(root);
        sections = collectSections(root);

        if (mq.matches) {
            attachScroll();
            handleParallax();
        } else {
            detachScroll();
            resetTransforms();
        }
    }

    function boot() {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", () => init(document), { once: true });
        } else {
            init(document);
        }
    }

    // Bootstrap
    boot();

    // Editor Shopify: ricarica quando la section viene (ri)montata o selezionata
    document.addEventListener("shopify:section:load", e => {
        const container = e.target || document;
        init(container);
    });
    document.addEventListener("shopify:section:select", e => {
        const container = e.target || document;
        init(container);
    });

    // Cambi breakpoint: attiva/disattiva parallax
    const onMqChange = e => (e.matches ? init(document) : (detachScroll(), resetTransforms()));
    if (mq.addEventListener) mq.addEventListener("change", onMqChange);
    else mq.addListener(onMqChange); // fallback Safari vecchi
})();